import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pageTitle: "",
    user: {},
    layout: {},
    db_access: false,
  },
  mutations: {
    updateUser(state, payload) {
      state.user = payload;
    },
    updateLayout(state, payload) {
      state.layout = payload;
    },
    updateDBAccess(state, payload) {
      state.db_access = payload;
    },
    updateTitle(state, payload) {
      localStorage.setItem("pageTitle", payload);
      state.pageTitle = payload;
    },
  },
  actions: {
    checkUser({ commit }, payload) {
      commit("updateUser", payload);
    },
  },
  getters: {
    getUser(state) {
      if (Object.keys(state.user).length > 0) {
        return state.user;
      } else if (window.localStorage.getItem("userData")) {
        return JSON.parse(window.localStorage.getItem("userData"));
      }
      return state.user;
    },
    layoutGetter(state) {
      return state.layout;
    },
    getDBAccess(state) {
      return state.db_access;
    },
    // getPageTitle(state) {
    //   return state.pageTitle;
    // },
  },
});
